import type { LinkableEntry } from "./compendium-links";

const loaded = new Map<string, Promise<readonly LinkableEntry[]>>();

interface PageNames {
  id: string;
  displayName: string;
  aliases?: string[];
}

async function fetchCharacters(bookId: string): Promise<readonly LinkableEntry[]> {
  const response = await fetch(`/book-data/${bookId}/character-pages.json`);
  if (!response.ok || !(response.headers.get("content-type") ?? "").includes("json")) {
    return [];
  }
  const { characters } = await response.json() as { characters: PageNames[] };
  return characters.map((character) => ({
    id: character.id,
    kind: "character",
    name: character.displayName,
    aliases: character.aliases ?? [],
    looseCase: false,
  }));
}

/** A book's characters, as things story text can link to. Fetched once. */
export function loadCharacterLinks(bookId: string): Promise<readonly LinkableEntry[]> {
  let links = loaded.get(bookId);
  if (links === undefined) {
    links = fetchCharacters(bookId).catch(() => []);
    loaded.set(bookId, links);
  }
  return links;
}
